import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import { GetDatosCorreo, GuardarDatosCorreo } from 'App/Administracion/Actions';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

function FormCorreo(props) {
  const { classes } = props;

  const [datosCorreo, setDatosCorreo] = useState({ CorreoEmpresa: {}, CorreoSii: {} });
  const [tab, setTab] = useState(0);

  useEffect(() => {
    GetDatosCorreo((datosCorreo) => {
      setDatosCorreo(datosCorreo)
  })
  }, []);

  function guardarCorreo() {
    if((datosCorreo.CorreoEmpresa.ServidorRecepcion||"").includes("pop.gmail.com") || (datosCorreo.CorreoSii.ServidorRecepcion||"").includes("pop.gmail.com")
      || (datosCorreo.CorreoEmpresa.ServidorRecepcion||"").includes("pop.google.com") || (datosCorreo.CorreoSii.ServidorRecepcion||"").includes("pop.google.com")
    ){
      alert("Correos Gmail sólo pueden ser IMAP");
      return;
    }
    var conf = window.confirm("¿Está seguro de querer actualizar el registro?");

    if(conf){
      GuardarDatosCorreo(datosCorreo, () => {
        alert("Datos de correo electrónico guardados con éxito");
      })
    }
  }

  return (
      <Grid container spacing={24}>
        <Grid item sm={12}>
          <Typography gutterBottom variant="h5" component="h2">Administrar correo electrónico</Typography>
          <Typography gutterBottom variant="subtitle1">Acá puede ingresar los datos de conexión de los correos configurados en el SII.</Typography>
          <Typography gutterBottom variant="subtitle2">Para cambiar los correos, el Representante Legal debe ingresar a <a target="_blank" href="https://palena.sii.cl/cvc_cgi/dte/ad_empresa1">Actualización de Datos de la Empresa</a> y hacer los ajustes.</Typography>
          <Typography gutterBottom variant="subtitle2">¿Correo Microsoft 365? <a href ="/api/Administracion/Correo/Permisos">Debe entregar permisos a la aplicación acá</a></Typography>
        </Grid>
        <Grid item sm={12}>
        <Tabs
          value={tab}
          onChange={(e,v)=>setTab(v)}
          indicatorColor="primary"
          textColor="primary"
          centered
          variant="fullWidth"
        >
          <Tab label="Correo Empresas" />
          <Tab label="Correo Sii" />
        </Tabs>
        {tab == 0 && <TabContainer>
          <Grid container spacing={12}>
              <Grid item sm={2} md={4}>
              </Grid>
              <Grid item xs={12} sm={8} md={4}>
                <Grid container spacing={24}>
                  <Grid item sm={12}>
                    <TextField
                      disabled
                      label="Correo"
                      fullWidth
                      type="email"
                      value={datosCorreo.CorreoEmpresa.Email||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, Email: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Servidor de salida"
                      fullWidth
                      value={datosCorreo.CorreoEmpresa.ServidorSmtp||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, ServidorSmtp: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Puerto de salida"
                      fullWidth
                      value={datosCorreo.CorreoEmpresa.PuertoSmtp||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, PuertoSmtp: e.target.value } })}
                      margin="normal"
                      type="number"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={datosCorreo.CorreoEmpresa.SslSmtp||false}
                          onChange={(e,c) => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, SslSmtp: c } })}
                        />
                      }
                      label="Habilitar SSL"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Usuario servidor de salida"
                      fullWidth
                      value={datosCorreo.CorreoEmpresa.UsuarioSmtp||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, UsuarioSmtp: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Contraseña servidor de salida"
                      fullWidth
                      type="password"
                      value={datosCorreo.CorreoEmpresa.ClaveSmtp||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, ClaveSmtp: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Servidor de recepción"
                      fullWidth
                      value={datosCorreo.CorreoEmpresa.ServidorRecepcion||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, ServidorRecepcion: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Puerto de recepcion"
                      fullWidth
                      value={datosCorreo.CorreoEmpresa.PuertoRecepcion||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, PuertoRecepcion: e.target.value } })}
                      margin="normal"
                      type="number"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={datosCorreo.CorreoEmpresa.SslRecepcion||false}
                          onChange={(e,c) => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, SslRecepcion: c } })}
                        />
                      }
                      label="Habilitar SSL"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Usuario servidor de recepcion"
                      fullWidth
                      value={datosCorreo.CorreoEmpresa.UsuarioRecepcion||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, UsuarioRecepcion: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Contraseña servidor de recepción"
                      fullWidth
                      type="password"
                      value={datosCorreo.CorreoEmpresa.ClaveRecepcion||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, ClaveRecepcion: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <FormControl className={classes.formControl} fullWidth>
                      <InputLabel htmlFor="age-simple">Tipo de recepción</InputLabel>
                      <Select
                        value={datosCorreo.CorreoEmpresa.TipoRecepcion||false}
                        onChange={e => setDatosCorreo({ ...datosCorreo, CorreoEmpresa: { ...datosCorreo.CorreoEmpresa, TipoRecepcion: e.target.value } })}>
                        <MenuItem value={false}>POP3</MenuItem>
                        <MenuItem value={true}>IMAP</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={12}>
                    <Button onClick={(e) => { e.preventDefault(); guardarCorreo(); }} variant="contained" size="large" color="primary" className={classes.button}>
                      Guardar
                </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </TabContainer>}
          {tab == 1 && <TabContainer>
          <Grid container spacing={12}>
              <Grid item sm={2} md={4}>
              </Grid>
              <Grid item xs={12} sm={8} md={4}>
                <Grid container spacing={24}>
                  <Grid item sm={12}>
                    <TextField
                      label="Correo"
                      fullWidth
                      type="email"
                      value={datosCorreo.CorreoSii.Email||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, Email: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Servidor de salida"
                      fullWidth
                      value={datosCorreo.CorreoSii.ServidorSmtp||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, ServidorSmtp: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Puerto de salida"
                      fullWidth
                      value={datosCorreo.CorreoSii.PuertoSmtp||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, PuertoSmtp: e.target.value } })}
                      margin="normal"
                      type="number"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={datosCorreo.CorreoSii.SslSmtp||false}
                          onChange={(e,c) => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, SslSmtp: c } })}
                        />
                      }
                      label="Habilitar SSL"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Usuario servidor de salida"
                      fullWidth
                      value={datosCorreo.CorreoSii.UsuarioSmtp||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, UsuarioSmtp: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Contraseña servidor de salida"
                      fullWidth
                      type="password"
                      value={datosCorreo.CorreoSii.ClaveSmtp||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, ClaveSmtp: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Servidor de recepción"
                      fullWidth
                      value={datosCorreo.CorreoSii.ServidorRecepcion||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, ServidorRecepcion: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Puerto de recepcion"
                      fullWidth
                      value={datosCorreo.CorreoSii.PuertoRecepcion||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, PuertoRecepcion: e.target.value } })}
                      margin="normal"
                      type="number"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={datosCorreo.CorreoSii.SslRecepcion||false}
                          onChange={(e,c) => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, SslRecepcion: c } })}
                        />
                      }
                      label="Habilitar SSL"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Usuario servidor de recepcion"
                      fullWidth
                      value={datosCorreo.CorreoSii.UsuarioRecepcion||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, UsuarioRecepcion: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <TextField
                      label="Contraseña servidor de recepción"
                      fullWidth
                      type="password"
                      value={datosCorreo.CorreoSii.ClaveRecepcion||""}
                      onChange={e => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, ClaveRecepcion: e.target.value } })}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <FormControl className={classes.formControl} fullWidth>
                      <InputLabel htmlFor="age-simple">Tipo de recepción</InputLabel>
                      <Select
                        value={datosCorreo.CorreoSii.TipoRecepcion||false}
                        onChange={e => setDatosCorreo({ ...datosCorreo, CorreoSii: { ...datosCorreo.CorreoSii, TipoRecepcion: e.target.value } })}>
                        <MenuItem value={false}>POP3</MenuItem>
                        <MenuItem value={true}>IMAP</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={12}>
                    <Button onClick={(e) => { e.preventDefault(); guardarCorreo(); }} variant="contained" size="large" color="primary" className={classes.button}>
                      Guardar
                </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </TabContainer>}
          </Grid>
      </Grid>
  )
}

export default withStyles(styles)(FormCorreo);